import { render, staticRenderFns } from "./InventoryAnalysis.vue?vue&type=template&id=368c412c"
import script from "./InventoryAnalysis.vue?vue&type=script&lang=js"
export * from "./InventoryAnalysis.vue?vue&type=script&lang=js"
import style0 from "./InventoryAnalysis.vue?vue&type=style&index=0&id=368c412c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports